// Adds/removes a class to <body> when the menu drawer is open on mobile
(function () {
  function updateBodyClass() {
    var details = document.querySelector('header-drawer details.menu-drawer-container');
    if (!details) return;
    if (details.open && window.innerWidth < 750) {
      document.body.classList.add('menu-drawer-open');
    } else {
      document.body.classList.remove('menu-drawer-open');
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    var details = document.querySelector('header-drawer details.menu-drawer-container');
    if (!details) return;
    details.addEventListener('toggle', updateBodyClass);
    window.addEventListener('resize', updateBodyClass);
    updateBodyClass();
  });
})();
